
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Save from "@/components/Builder/TopBar/Save.vue";
import { uiStore } from "@/store/store";

@Component({
  components: {
    Save
  }
})
export default class TopNavSave extends Vue {
  get unsavedChangesPresent() {
    return uiStore.unsavedChangesPresent;
  }
}
